var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebFailureOtp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5 5.75C28.9193 5.75 5.75 28.9193 5.75 57.5C5.75 86.0807 28.9193 109.25 57.5 109.25C86.0807 109.25 109.25 86.0807 109.25 57.5C109.25 28.9193 86.0807 5.75 57.5 5.75ZM41.8619 35.7631C40.1778 34.079 37.4472 34.079 35.7631 35.7631C34.079 37.4472 34.079 40.1778 35.7631 41.8619L51.4012 57.5L35.7631 73.1381C34.079 74.8222 34.079 77.5528 35.7631 79.2369C37.4472 80.921 40.1778 80.921 41.8619 79.2369L57.5 63.5988L73.1381 79.2369C74.8222 80.921 77.5528 80.921 79.2369 79.2369C80.921 77.5528 80.921 74.8222 79.2369 73.1381L63.5988 57.5L79.2369 41.8619C80.921 40.1778 80.921 37.4472 79.2369 35.7631C77.5528 34.079 74.8222 34.079 73.1381 35.7631L57.5 51.4012L41.8619 35.7631Z",
    fill: "#F04438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebFailureOtp);
export default __webpack_public_path__ + "static/media/web-failure-otp.539624aac945bf0b69986e76f47c4fe6.svg";
export { ForwardRef as ReactComponent };